<template>
  <div id="containt" style="padding-left: 10px;">

    <div class="grid-height" style=" height: calc(100vh - -77px);">
      <vxe-grid align="center" show-overflow :stripe="true" :border="true" height="100%"
        :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
        @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

        <template #form>
          <div class="clearfix screen-btns" style="margin-top: 3px;">
            <div class="fl">
              <vxe-button status="primary" class="button-sty" icon="el-icon-plus" @click="doExcle">导出</vxe-button>
            </div>
            <div class="fr">
              <vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索</vxe-button>
            </div>
          </div>
          <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="requestParam"
            @submit="searchEvent" @reset="searchEvent">
            <vxe-form-item title="服务中心:">
              <template v-slot >
                <org-search :org-name.sync="formData.orgName"
                            :org-id-path.sync="formData.orgIdPath"
                            :org-id.sync="formData.orgId"
                            :show="!currentIsSite"
                            style="width:9vw ;"
                            @change="() => {
                              formData.siteId = null
                              formData.siteName = null
                              formData.childSiteId = null
                              formData.childSiteName = null
                            }"
                />
              </template>
            </vxe-form-item>

            <vxe-form-item title="服务商:">
              <template v-slot >
                <site-pop-search :site-id.sync="formData.siteId"
                                 :site-name.sync="formData.siteName"
                                 :org-name.sync="formData.orgName"
                                 :org-id-path.sync="formData.orgIdPath"
                                 :org-id.sync="formData.orgId"
                                 :editable="!currentIsSite"
                                 :param="{siteFloorLevel: 1}"
                                 @valueChange="() => {formData.childSiteId = null; formData.childSiteName = null}"
                                 style="width:9vw ;"/>
              </template>
            </vxe-form-item>

            <vxe-form-item title="年度:">
              <template v-slot>
                <el-date-picker
                  v-model="formData.year"
                  type="year"
                  placeholder="选择年度"
                  size="small"
                  clearable
                  style="width:9vw;"
                  value-format="yyyy"
                />
              </template>
            </vxe-form-item>

            <vxe-form-item title="月份:">
              <template v-slot>
                <el-select v-model="formData.month" style="width:9vw ;" clearable>
                  <el-option :value="1" label="1月"></el-option>
                  <el-option :value="2" label="2月"></el-option>
                  <el-option :value="3" label="3月"></el-option>
                  <el-option :value="4" label="4月"></el-option>
                  <el-option :value="5" label="5月"></el-option>
                  <el-option :value="6" label="6月"></el-option>
                  <el-option :value="7" label="7月"></el-option>
                  <el-option :value="8" label="8月"></el-option>
                  <el-option :value="9" label="9月"></el-option>
                  <el-option :value="10" label="10月"></el-option>
                  <el-option :value="11" label="11月"></el-option>
                  <el-option :value="12" label="12月"></el-option>

                </el-select>
              </template>
            </vxe-form-item>

            <vxe-form-item title="配件编码:">
              <template v-slot >
                <el-input v-model="formData.partsCode" size="small" clearable style="width:9vw ;"/>
              </template>
            </vxe-form-item>

          </vxe-form>
        </template>
        <!-- 分页器 -->
        <template #pager>
          <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
        </template>
      </vxe-grid>
    </div>

  </div>
</template>

<script>
import { initVxeTable } from '@/const/crud/admin/table'
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import OrgSearch from "@/components/formItem/orgSearch.vue";
import SitePopSearch from "@/components/formItem/sitePopSearch.vue";
import ChildSitePopSearch from "@/components/formItem/childSitePopSearch.vue";
import fileNames from "@/api/intfDownloadRecord/fileNames";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import {siteMixins} from "@/mixins/tabChang";
import {mapGetters} from "vuex";
// import { initVxeTable } from '@/const/crud/admin/fakeDataTable'

export default {
  name: 'partsReturnReport',
  mixins: [siteMixins],
  components: {ChildSitePopSearch, SitePopSearch, OrgSearch, pager },
  data() {
    return {
      getPageDataUrl: '/basic/basCompanyBarcode/getListPage',
      showEdit: false,
      editViewDataUpdateFlag: false,
      activeName: 'second',
      dataId: 0,
      pageSizes: [10, 20, 100],
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 10,  // 页面数据量

        orgId:null,
        siteId: null,
        partsCode:null,
        year:null,
        month:null
      },
      formData: {
        orgId:null,
        siteId: null,
        partsCode:null,
        year:null,
        month:null
      },
      searchBarcode: '',
      searchItemCode: '',
      searchItemName: '',
      total: 0,  // 数据总数
      vxeOption: {},

      columns: [
        {title: '服务商编码', field: 'siteCode', width: 130, },
        {title: '服务商名称', field: 'siteName', width: 180, },
        {title: '配件编码', field: 'partsCode', width: 130,},
        {title: '配件名称', field: 'partsName', width: 130,},
        {title: '年份', field: 'year', width: 80,},
        {title: '1月用量', field: 'monthUsage1', width: 80,},
        {title: '2月用量', field: 'monthUsage2', width: 80,},
        {title: '3月用量', field: 'monthUsage3', width: 80,},
        {title: '4月用量', field: 'monthUsage4', width: 80,},
        {title: '5月用量', field: 'monthUsage5', width: 80,},
        {title: '6月用量', field: 'monthUsage6', width: 80,},
        {title: '7月用量', field: 'monthUsage7', width: 80,},
        {title: '8月用量', field: 'monthUsage8', width: 80,},
        {title: '9月用量', field: 'monthUsage9', width: 80,},
        {title: '10月用量', field: 'monthUsage10', width: 80,},
        {title: '11月用量', field: 'monthUsage11', width: 80,},
        {title: '12月用量', field: 'monthUsage12', width: 80,},
        {title: '年度合计', field: 'yearCount', width: 80,},
        {title: '月均用量', field: 'avgMonth', width: 80,},

      ],
    };
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    setSiteData() {
      this.formData.siteId = this.currentSiteData.id
      this.formData.siteName = this.currentSiteData.userName
      this.formData.orgIdPath = this.currentSiteData.snSiteInfoDTO.orgIdPath
      this.formData.orgId = this.currentSiteData.snSiteInfoDTO.orgId
      this.formData.orgName = this.currentSiteData.snSiteInfoDTO.orgName
      this.$objCopy(this.formData, this.requestParam)
    },


    //导出
    doExcle(){
      this.$mask.open()
      doCheckExcle(fileNames.repairItemPartUsage).then(response => {
        if (response.data.msg=="success"){
          doDownLoadExcle(api.repairItemPartUsage.doExcelUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          }).catch(() => {
            this.$mask.close()
          })
        }else{
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },

    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.repairItemPartUsage.getPage,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {
      this.searchBarcode = ''
      this.searchItemName = ''
      this.searchItemCode = ''
      this.requestParam.searchCount = false
      this.requestParam.year = ''
      this.requestParam.partsCode = ''
      this.requestParam.month = ''
      this.requestParam.orgId = ''
      this.requestParam.siteId = ''
      this.requestParam.current = 1
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 新增
    openEditDialog(id) {
      console.log(id)
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
  }
};
</script>
<style lang="scss" >
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}


</style>
